import { render } from "./UserCard.vue?vue&type=template&id=68fdcbca&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=ts"
export * from "./UserCard.vue?vue&type=script&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=68fdcbca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68fdcbca"

export default script